import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import style from './permissionRoles.module.css';
import styleForm from '../../../../common/theme/styles/form.module.css';

import { Formik, Form, Field } from "formik";
import * as yup from "yup";

import { RolDto } from "../../dtos/rol.dto";
import CardRoles from "../../components/cardRoles";

import { GetRolesService } from "../../services/admin/permissionRoles/getRoles.service";
import { CreateOrUpdateRoleService } from "../../services/admin/permissionRoles/createOrUpdateRole.service";
import { InputText, InputTextArea } from "../../../../common/UI/Inputs";
import AppGetIcon from "../../../../common/UI/AppGetIcon";
import { useHeaderStore } from "../../../../store/header.store";
import { shallow } from "zustand/shallow";
import ModalNew from "../../../../common/UI/Modal";
import ProgressBar from "../../../../common/UI/ProgressBar";
import { toast } from "react-toastify";
import { DeleteRoleService } from "../../services/admin/permissionRoles/deleteRole.service";
import Modal from "../../../../common/UI/DataTable/modal/modal";
import DeleteConfirmationModal from "../../../../common/UI/DataTable/DeleteConfirmationModal/deleteConfirmationModal";
// import usePermission from "../../../../common/hooks/usePermission";

const deleteRoleService = new DeleteRoleService();
const createOrUpdateRoleService = new CreateOrUpdateRoleService();
export default function Roles() {
  const navigate = useNavigate();
  // const canCreateRole = usePermission('booking.roles', 'create');

  const [loading, setLoading] = useState<boolean>(true);
  const [rolesData, setRolesData] = useState<RolDto[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCurrentDelete, setIsOpenCurrentDelete] = useState<any>(null);
  const [dataCreateRol, setDataCreateRol] = useState<RolDto>(
    {
      id: 0,
      name: '',
      description: '',
      isActive: true

    }
  );
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow
  );
  useEffect(() => {
    headerStore.setModule('Administración', '');
    headerStore.setModuleItem('Roles', '/admin/roles');
    getDataRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataRoles = async () => {
    try {
      let response = await GetRolesService();
      setRolesData(response);
      setLoading(false);
    } catch (error) {
      console.log('error roles', error);
      setLoading(false);
    };
  }
  const handleCreatedRole = () => {
    setDataCreateRol(
      {
        id: 0,
        name: '',
        description: '',
        isActive: true
      }
    )
    setIsOpen(true);
  };
  const handleEdit = async (role: any) => {
    setDataCreateRol({
      id: Number(role.id),
      name: role.name,
      description: role.description,
      isActive: role.isActive
    })
    setIsOpen(true);
  };
  const handleCloseModalDelete = () => {
    setIsOpenCurrentDelete(false);
  };
  const handleDelete = async () => {
    if (!isOpenCurrentDelete) return;

    setLoading(true);
    try {
      const response: any = await deleteRoleService.run(isOpenCurrentDelete.id);
      toast.success(
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <AppGetIcon name="checkCircleFill" />
          {response.message}
        </div>,
        { icon: false }
      );
      setIsOpenCurrentDelete(null);
      await getDataRoles(); // recarga los roles
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      toast.error(
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <AppGetIcon name="xCircleFill" />
          {errorMessage}
        </div>,
        { icon: false }
      );
      console.error("Error al eliminar el rol:", error);
    } finally {
      setLoading(false);
    }
  };




  const handleCloseModal = () => {
    setIsOpen(false);
    setDataCreateRol(
      {
        id: null,
        name: '',
        description: '',
        isActive: true
      }
    );
  };

  const RoleSchema = yup.object().shape({
    name: yup.string().required("nombre es requerido"),
    description: yup.string().required("La descripción es requerida"),
  });

  const handleSubmit = async (values: any, actions: any) => {
    if (actions.errors && Object.keys(actions.errors).length !== 0) {
      actions.setSubmitting(false);
      return;
    }
    setLoading(true);
    try {
      let dataCreated = {
        id: dataCreateRol.id > 0 ? dataCreateRol.id : null, // este `id` decide si es POST o PATCH en el servicio
        name: values.name,
        description: values.description,
        isActive: values.isActive ?? false
      };

      await handleCloseModal();
      let idEditRol = dataCreateRol.id > 0 ? dataCreateRol.id : null;

      const response = await createOrUpdateRoleService.run(dataCreated, idEditRol);

      await getDataRoles();
      toast.success(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="checkCircleFill" />
          {response.message}
        </div>,
        { icon: false }
      );
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || "Error";
      toast.error(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="xCircleFill" />
          {errorMessage}
        </div>,
        { icon: false }
      );
    } finally {
      setLoading(false);
    }

    actions.setSubmitting(false);
  };
  const handlePermissions = (role: any) => {
    navigate(`/adminUsers/roles/${role.id}/permissions/${role.name}`);
  };
  return (
    <div className={loading ? style.containerRols + " " + style.containserLoading : style.containerRols}>
      {
        loading ? <ProgressBar width='calc(100% - 0px)' height='calc(100vh - 57px)' /> :
          <>
            {
              <div className={style.cardAdd} onClick={handleCreatedRole} >
                <AppGetIcon name="plus" strokeColor="var(--color-on-surface-variant-main)" /> Crear
              </div>
            }

            {
              rolesData && rolesData.map((role: RolDto, index: number) =>
                <CardRoles
                  key={index}
                  title={role.name}
                  titlePosition='start'
                  description={role.description}
                  backgroundColor='#4c43ac'
                  titleColor='#FFF'
                  handleEdit={() => handleEdit(role)}
                  handleDelete={() => setIsOpenCurrentDelete(role)}
                  handlePermissions={() => handlePermissions(role)}

                />
              )
            }
          </>
      }

      <Modal title={dataCreateRol.id ? `Editar Rol` : 'Crear Rol'} isOpen={isOpen} onClose={handleCloseModal} size={{ width: '500px', height: 'auto' }}
        footerContent={
          <Formik
            initialValues={{ name: dataCreateRol.name ?? '', description: dataCreateRol.description ?? '', isActive: Boolean(dataCreateRol.isActive), }}
            validationSchema={RoleSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <div className={style.containerButtoms}>
                <button
                  className={styleForm.buttomFooter + ' ' + styleForm.buttom_cancelar}
                  onClick={handleCloseModal}
                >
                  Cancelar
                </button>
                <button
                  form="activityForm"
                  type="submit"
                  className={styleForm.buttomFooter}
                  disabled={isSubmitting}
                >
                  Guardar
                </button>
              </div>
            )}
          </Formik>
        }
      >
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
          <Formik
            initialValues={{ name: dataCreateRol.name ?? '', description: dataCreateRol.description ?? '', isActive: Boolean(dataCreateRol.isActive), }}
            validationSchema={RoleSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors }) => (
              <Form id="activityForm" className="flex-row" style={{ width: '100%' }}>
                <InputText
                  type="text"
                  classNameInput={styleForm.input__input}
                  name="name"
                  placeholder="Nombre rol"
                  TextLabel="Nombre*"
                />
                <InputTextArea
                  name="description"
                  classNameInput={styleForm.input__input}

                  placeholder="Descripción rol"
                  TextLabel="Descripción*"
                />
                <div>
                  <label className={style.title}>Activo</label>
                  <Field
                    name="isActive"
                    render={({ field }: any) => (
                      <>
                        <input
                          {...field}
                          id="isActive"
                          type="checkbox"
                          checked={field.value}
                        />
                      </>
                    )}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      {/* Modal Confirmación de Eliminado (nuevo componente) */}
      <DeleteConfirmationModal
        isOpen={Boolean(isOpenCurrentDelete)}
        onClose={handleCloseModalDelete}
        onConfirm={handleDelete}
        loading={loading}
        itemName={isOpenCurrentDelete?.name}               // muestra el nombre del rol
        customMessage="¿Está seguro que desea eliminar el rol seleccionado?"
      />
    </div>

  )
}
